import { memo, MouseEventHandler, ReactNode } from 'react'
import { Box, Flex } from '@stoplight/mosaic'

type TableOfContentsItemProps = {
  title: string
  depth: number
  isActive?: boolean
  id?: string
  meta?: ReactNode
  onClick?: MouseEventHandler
}

export const TableOfContentsItem = memo<TableOfContentsItemProps>(
  ({ depth, isActive, id, title, meta, onClick }) => {
    return (
      <Flex
        id={id}
        bg={{
          default: isActive ? 'primary-tint' : 'canvas',
          hover: isActive ? undefined : 'canvas-200',
        }}
        className="sl-rounded-t-lg sl-rounded-b-lg"
        cursor="pointer"
        // @ts-expect-error
        pl={4 + depth * 4}
        pr={4}
        mt={depth === 0 ? 4 : undefined}
        h="md"
        align="center"
        userSelect="none"
        onClick={onClick}
        title={title}
      >
        <Box
          alignItems="center"
          flex={1}
          mr={meta ? 1.5 : undefined}
          textOverflow="truncate"
          textTransform={depth === 0 ? 'uppercase' : undefined}
          fontWeight={depth === 0 ? 'bold' : 'normal'}
        >
          {title}
        </Box>
        {meta && (
          <Flex alignItems="center" fontSize="xs">
            {meta}
          </Flex>
        )}
      </Flex>
    )
  }
)
